import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCancelRescheduleRequests } from "../../../actions/admin/cancelreschedulerequest";
import AdminPage from "../_components/AdminPage";
import AdminTable from "../_components/AdminTable";
import CancelRescheduleRequestItem from "./CancelRescheduleRequestItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "customer", title: "Customer", width: "tw:w-[220px]", skeleton: "stacked" },
  { key: "type", title: "Type", width: "tw:w-[180px]", skeleton: "badge" },
  { key: "requestedAt", title: "Request At", width: "tw:w-[180px]" },
  { key: "bookingDate", title: "Booking Date", width: "tw:w-[170px]" },
  { key: "requestedDate", title: "Booking Requested Date", width: "tw:w-[220px]" },
  { key: "payment", title: "Payment Status", width: "tw:w-[200px]", skeleton: "badge" },
  { key: "approval", title: "Approval Status", width: "tw:w-[200px]", skeleton: "badge" },
  { key: "admin", title: "Admin", width: "tw:w-[160px]" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const CancelRescheduleRequestList = () => {
  const cancelreschedulerequest = useSelector((state) => state.cancelreschedule);
  const { loading, cancelreschedulerequests } = cancelreschedulerequest;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCancelRescheduleRequests());
  }, [dispatch]);

  const rows = cancelreschedulerequests?.data || [];

  return (
    <AdminPage title="Cancellation and Reschedule Requests">
      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1710}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!rows.length}
        emptyText="No requests found."
      >
        {rows.map((item, index) => (
          <CancelRescheduleRequestItem key={item._id} cancelreschedulerequest={item} count={index} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default CancelRescheduleRequestList;
